import { Browser } from "@capacitor/browser";
import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, Link } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";

import { SupportArticles, SupportContext } from "../support/constants";

export interface IcAgreementHelpTextProps {
  contactSupportLinks: {
    signIcAgreementSupportLink: string;
    howToContactSupportLink: string;
  };
  userId: string;
}

export function IcAgreementHelpText(props: IcAgreementHelpTextProps) {
  const {
    contactSupportLinks: { signIcAgreementSupportLink, howToContactSupportLink },
    userId,
  } = props;

  if (!isDefined(userId)) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", paddingLeft: 0, flexWrap: "wrap" }}>
      <Text variant="body2" color="inherit" display="inline">
        Having trouble signing?
      </Text>
      &nbsp;
      <Text variant="body2" color="inherit" display="inline">
        Please check the
      </Text>
      &nbsp;
      <Link
        variant="body2"
        sx={{
          color: "inherit",
          textDecorationColor: "inherit",
          ":hover": {
            color: "inherit",
            textDecoration: "underline",
          },
        }}
        onClick={async () => {
          await Browser.open({
            url: signIcAgreementSupportLink,
            windowName: "_blank",
            presentationStyle: "popover",
          });
          logEvent(APP_V2_USER_EVENTS.OPENED_SUPPORT_ARTICLE, {
            articleLink: signIcAgreementSupportLink,
            articleName: SupportArticles.SIGN_IC_AGREEMENT,
            userId,
            supportContext: SupportContext.IC_AGREEMENT_ERROR_ALERT,
          });
        }}
      >
        <b>&ldquo;Unable to sign the IC Agreement&rdquo;</b>
      </Link>
      &nbsp;
      <Text variant="body2" color="inherit" display="inline">
        help article
      </Text>
      &nbsp;
      <Text variant="body2" color="inherit" display="inline">
        or
      </Text>
      &nbsp;
      <Link
        variant="body2"
        sx={{
          color: "inherit",
          textDecorationColor: "inherit",
          ":hover": {
            color: "inherit",
            textDecoration: "underline",
          },
        }}
        onClick={async () => {
          await Browser.open({
            url: howToContactSupportLink,
            windowName: "_blank",
            presentationStyle: "popover",
          });
          logEvent(APP_V2_USER_EVENTS.OPENED_SUPPORT_ARTICLE, {
            articleLink: howToContactSupportLink,
            articleName: SupportArticles.HOW_TO_CONTACT_SUPPORT,
            userId,
            supportContext: SupportContext.IC_AGREEMENT_ERROR_ALERT,
          });
        }}
      >
        <b>contact support.</b>
      </Link>
    </Box>
  );
}
